import React from 'react'
import { Link } from "react-router-dom";
import HomeReviews from '../home/HomeReviews';
import HomeGallery from '../home/HomeGallery';


const Gallery = () => {
    return (
        <>

            <section className="page-hero bg_cover p-r z-1" style={{ backgroundImage: 'url("assets/img/TDR.jpg")' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            {/*=== Page Content ===*/}
                            <div className="page-content text-center">
                                <h1>Our Gallery</h1>
                                <ul>
                                    <li><Link to="/">Home</Link></li>
                                    <li> Our Gallery</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div style={{ marginTop: "100px" }}>
                <HomeGallery />
            </div>
            <div className="container" style={{ marginTop: "-90px" }}>
                <div className="row">
                    <div className="col-xl-3 col-md-6 col-sm-12">
                        <div className="renvia-team-item style-one mb-40 aos-init aos-animate" data-aos="fade-up" data-aos-duration={1000}>
                            <div className="member-image">
                               <iframe width="560" height="300" src="https://www.youtube.com/embed/zxqFQzk7I94?si=QIjMYZ-RafQ-c4-I" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 col-sm-12">
                        <div className="renvia-team-item style-one mb-40 aos-init aos-animate" data-aos="fade-up" data-aos-duration={1200}>
                            <div className="member-image">
                                <iframe width="560" height="300" src="https://www.youtube.com/embed/t3rwakpx_d4?si=sUS5oQXO75LjUYhq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 col-sm-12">
                        <div className="renvia-team-item style-one mb-40 aos-init aos-animate" data-aos="fade-up" data-aos-duration={1400}>
                            <div className="member-image">
                                <iframe width="560" height="300" src="https://www.youtube.com/embed/BTZMG7Nc9bo?si=i4v2FlDAzlM2fpK_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 col-sm-12">
                        <div className="renvia-team-item style-one mb-40 aos-init aos-animate" data-aos="fade-up" data-aos-duration={1600}>
                            <div className="member-image">
                                <iframe width="560" height="300" src="https://www.youtube.com/embed/XpCstl6_fZk?si=okjhkmfN8kOH9d9H" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginTop: "-00px" }}>
                <div className="row">
                    <div className="col-xl-3 col-md-6 col-sm-12">
                        <div className="renvia-team-item style-one mb-40 aos-init aos-animate" data-aos="fade-up" data-aos-duration={1000}>
                            <div className="member-image">
                               <iframe width="560" height="300" src="https://www.youtube.com/embed/mCFZwo8brqE?si=zmmk1Xlgbdjhzit8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 col-sm-12">
                        <div className="renvia-team-item style-one mb-40 aos-init aos-animate" data-aos="fade-up" data-aos-duration={1200}>
                            <div className="member-image">
                                <iframe width="560" height="300" src="https://www.youtube.com/embed/iGNgW6kme1A?si=9ym65dM9FlU5n55c" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 col-sm-12">
                        <div className="renvia-team-item style-one mb-40 aos-init aos-animate" data-aos="fade-up" data-aos-duration={1400}>
                            <div className="member-image">
                                <iframe width="560" height="300" src="https://www.youtube.com/embed/9fjOxM2k_f4?si=-CX1LzAjQHnFI08Q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 col-sm-12">
                        <div className="renvia-team-item style-one mb-40 aos-init aos-animate" data-aos="fade-up" data-aos-duration={1600}>
                            <div className="member-image">
                                <iframe width="560" height="300" src="https://www.youtube.com/embed/2B0Ii0smP_w?si=XLnIwj-_b97JB1jv" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>




        </>
    )
}

export default Gallery